import InstagramServices, { InstagramMediaContentData, InstagramResponse } from '../../../Services/InstagramServices';
import SystemServices from '../../../Services/SystemServices';

type ApiIsConfiguredCallbackResult = {
	isConfigured?: boolean;
	isError?: boolean
}

export type InstagramEditorServiceType = {
	apiIsConfigured: (callback: (result: ApiIsConfiguredCallbackResult) => void) => void;
	getMediaListPage: (
		previousPageCursor: string | null,
		nextPageCursor: string | null,
		callbackSuccess: (page: InstagramResponse) => void,
		callbackError?: (error: any) => void) => void;
	getMediaContent: (
		mediaId: string,
		callbackSuccess: (data: InstagramMediaContentData) => void,
		callbackError?: (error: any, result?: any) => void) => void;
	getMediaContentAsync: (
		mediaId: string) =>
		Promise<InstagramMediaContentData>;
};

export default function InstagramEditorService(services: InstagramServices, systemServices: SystemServices): InstagramEditorServiceType {

	const apiIsConfigured = (callback: (result: ApiIsConfiguredCallbackResult) => void) => {
		services.getToken(
			() =>
				callback({
					isConfigured: true
				}),
			() =>
				callback({
					isConfigured: false
				}),
			() => {
				systemServices.showError('An error occured while checking Instagram API');
				callback({
					isError: true

				});
			}
		);
	};

	const getMediaListPage = (
		previousPageCursor: string | null,
		nextPageCursor: string | null,
		callbackSuccess: (page: InstagramResponse) => void,
		callbackError?: (error: any) => void) => {
		services.getMediaPage(previousPageCursor, nextPageCursor, callbackSuccess, (error: any, result?: any) => {
			console.log('error', result);
			systemServices.showError('Cannot get media from Instagram');
			callbackError && callbackError(error);
		});
	};

	const getMediaContent = (
		mediaId: string,
		callbackSuccess: (data: InstagramMediaContentData) => void,
		callbackError?: (error: any, result?: any) => void) => {
		const cachedVersion = sessionStorage.getItem('Insta' + mediaId);
		if (cachedVersion) {
			const value = JSON.parse(cachedVersion);
			if (Math.floor((Date.now() - value.exp) / 1000) < (5 * 3600)) { // 5 hours
				return callbackSuccess(value.data);
			}
		}
		services.getMediaContent(mediaId,
			(data) => {
				sessionStorage.setItem('Insta' + mediaId, JSON.stringify({ exp: Date.now(), data }));
				callbackSuccess(data);
			},
			(error: any, result?: any) => {
				console.log('error', result);
				callbackError && callbackError(error);
			});
	};

	const getMediaContentAsync = async (mediaId: string): Promise<InstagramMediaContentData> => {
		return new Promise((resolve, _) =>
			getMediaContent(mediaId, resolve, _ => resolve({ id: mediaId, media_url: '' }))
		);
	};

	return {
		apiIsConfigured,
		getMediaListPage,
		getMediaContent,
		getMediaContentAsync
	};
}